module.exports = __webpack_public_path__ + "static/media/068.b88d39fc.jpg";